// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "templates/assets/" + "b381befc9db30af5b269" + "." + chunkId + ".js";
};